module.exports = __webpack_public_path__ + "img/fitt_dark_clear_cropped_old.d940436c.png";